import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import MainLayOut from "./component/MainLayOut";
import { useEffect } from "react";
import Home from "./pages/Home";
import ContactUs from "./pages/contact-us/ContactUs";
import Gallery from "./pages/gallery/Gallery";
import Blog from "./pages/blog/Blog";
import TruckExpress from "./pages/blog/TruckExpress";
import BestLogistics from "./pages/blog/BestLogistics";
import BookAir from "./pages/blog/BookAir";
import About from "./pages/about/About";
import Services from "./pages/services/Services";
import RoadTransportation from "./pages/services/RoadTransportation";
import RailTransportation from "./pages/services/RailTransportation";
import AirTransportation from "./pages/services/AirTransportation";
import TrackOrder from "./pages/trackorder/TrackOrder";
import FounderMessage from "./pages/about/FounderMessage";



function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" exact element={<MainLayOut />}>
            <Route index element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/truck-express" element={<TruckExpress />} />
            <Route path="/best-logistics" element={<BestLogistics />} />
            <Route path="/book-air" element={<BookAir />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/road-transportation" element={<RoadTransportation />} />
            <Route path="/rail-transportation" element={<RailTransportation />} />
            <Route path="/air-transportation" element={<AirTransportation />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/founder-message" element={<FounderMessage />} />
           
            
           
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
